import createAction from '../redux-utils/create-action'

const SETTINGS = 'SETTINGS'

export const LOCALE_CHANGE = `[${SETTINGS}] LOCALE_CHANGE`
export const THEME_TYPE_TOGGLE = `[${SETTINGS}] THEME_TYPE_TOGGLE`

export enum Locale {
  EN = 'en',
  ES = 'es',
}

interface Settings {
  locale: Locale
  isDark: boolean
}

const init: Settings = {
  locale: Locale.ES,
  isDark: false,
}

const settingsReducer = (state = init, action) => {
  const { type, payload } = action

  switch (type) {
    case THEME_TYPE_TOGGLE:
      return {
        ...state,
        isDark: !state.isDark,
      }

    case LOCALE_CHANGE:
      return {
        ...state,
        locale: payload,
      }

    default:
      return state
  }
}

export type SettingsState = Settings

export default settingsReducer

export const changeLocale = (locale: Locale) =>
  createAction(
    LOCALE_CHANGE,
    locale,
  )

export const toggleThemeType = () =>
  createAction(THEME_TYPE_TOGGLE)

export const selectLocale = state =>
  state.settings.locale

export const selectThemeType = state =>
  state.settings.isDark



// WEBPACK FOOTER //
// ./src/redux/ducks/settings.duck.ts